export default class Model {
    // eslint-disable-next-line class-methods-use-this
    toObject() {
        return {};
    }

    serialize() {
        return {
            model: this.constructor.name,
            data: this.toObject()
        };
    }
}
